import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Session lives in an HTTP-only secure cookie set by the backend on /api/auth/login.
// `withCredentials: true` ensures the cookie rides along on every request.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // If session is invalidated/revoked, force logout to login screen.
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail || "";
    const onAuthPage = typeof window !== "undefined" && window.location.pathname === "/login";
    if (status === 401 && !onAuthPage) {
      const isSessionKilled = /Session invalidated|Access revoked|Token expired|User not found/i.test(String(detail));
      if (isSessionKilled) {
        window.location.assign("/login?revoked=1");
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Resolve a photo URL stored in the database.
 * - base64 data URLs are returned as-is (legacy records).
 * - "/api/uploads/..." relative paths are prefixed with the backend host.
 * - Anything else (empty / absolute) is returned untouched.
 */
export function resolvePhotoUrl(value) {
  if (!value) return "";
  if (value.startsWith("data:") || value.startsWith("http")) return value;
  if (value.startsWith("/api/")) return `${BACKEND_URL}${value}`;
  return value;
}
